// @ts-strict-ignore
import { numberWithCommas } from '~/helpers/formatting';
import { RECORD_COUNT_LIMITS } from './constants';
import type { AgentProps, CustomerProps } from './constants';

export const getOrganizationName = (agent: AgentProps, customer: CustomerProps) => {
  const { location: { pathname } } = window;
  const defaultName = 'Alloy Internal Dashboard';
  if (pathname.startsWith('/v3/dashboard/admin')) {
    if (agent?.isEmployee) return defaultName;
    return agent?.customerAgents?.[0]?.organizationName || defaultName;
  }
  return customer?.organizationName || defaultName;
};

export const calculateTitle = (
  prefix: string,
  rowCount: number,
  agent: AgentProps,
  customer: CustomerProps,
) => {
  const defaultTitle = 'Alloy: Identity Risk Solution for Financial Services';
  if (!prefix) return defaultTitle;
  try {
    const capitalizedEnv = agent && customer ? `- ${getOrganizationName(agent, customer)} ` : '';
    const recordCountLimit = RECORD_COUNT_LIMITS[prefix];
    const countSuffix = recordCountLimit && recordCountLimit <= rowCount ? '+' : '';
    const stringRowCount = rowCount > -1 ? `(${numberWithCommas(rowCount)}${countSuffix}) ` : '';
    return `${prefix} ${stringRowCount}${capitalizedEnv}| Alloy`;
  } catch (err) {
    return defaultTitle;
  }
};
